import ComponentBase from "../../../public/component/component_base";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import ModelData, { IUserData } from "../../../public/model_data";

const { ccclass, property, menu } = cc._decorator;


@ccclass
@menu('custom/TablePokerBase')
export default class TablePokerBase extends ComponentBase{
    @property(cc.Sprite)
    spriteBack: cc.Sprite = null

    @property(SpriteFrameHolder)
    backSpriteFrameHolder: SpriteFrameHolder = null

    get uid(){
        return this.m_uid
    }
    set uid(val){
        this.m_uid = val
        this.m_is_uid_dirty = true
    }

    protected m_uid: number = 0
    protected m_is_uid_dirty: boolean = false

    protected m_default_back_spriteframe: cc.SpriteFrame = null
    onLoad(){        
        this.spriteBack && (this.m_default_back_spriteframe = this.spriteBack.spriteFrame)
        this.eventBind('Event_Update_PaiBei', this.onUpdatePaiBei)   
    }

    protected onUpdatePaiBei(){
        this.m_is_uid_dirty = true
        this.onUpdateBack()
    }

    public onUpdateBack(){
        if(this.uid){
            if(this.m_is_uid_dirty){
                this.getUserData(this.uid, (data: IUserData)=>{
                    this.refreshBack(data.plizedCardIcon)
                })
            }            
        }        
    }

    refreshBack(spriteFrameName?: string){
        spriteFrameName = spriteFrameName || ''
        this.setBack(spriteFrameName)
    }

    protected setBack(key: string){
        if(this.spriteBack){
            !this.m_default_back_spriteframe && (this.m_default_back_spriteframe = this.spriteBack.spriteFrame)
            this.spriteBack.spriteFrame = this.getBackSpriteFrameByKey(key) || this.m_default_back_spriteframe
        }
    }

    protected getBackSpriteFrameByKey(key: string){
        return this.backSpriteFrameHolder ? this.backSpriteFrameHolder.getSpriteFrameByKey(key): null
    }
}
